import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiRoutes} from "../../config/api-routes";
import {map} from "rxjs";

@Injectable()
export class LicenseService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly apiRoutes: ApiRoutes,
  ) { }

  /**
   * Return the license formatted in HTML
   * as a string.
   * @param language
   */
  public licenseFor(language = 'en') {

    return this.httpClient.get<LicenseAgreementResponse>(this.apiRoutes.getRouteWithInjectedParams(this.apiRoutes.LICENSE, [language]))
      .pipe(map(({licenseAgreement}) => licenseAgreement));
  }

  public agree(loginId: number) {
    return this.httpClient.post<number>(this.apiRoutes.ACCEPT_LICENSE, loginId);
  }
}

export interface LicenseAgreementResponse {
  licenseAgreement: string
}

export interface AgreeWithLicenseRequest {
  loginId: number
}
